export default function Marquee({ items }) {
  const Row = ({ ariaHidden }) => (
    <div className="flex shrink-0 items-center" aria-hidden={ariaHidden}>
      {items.map((t, i) => (
        <span key={i} className="flex items-center">
          <span className="whitespace-nowrap px-8 font-serif italic text-xl sm:text-2xl text-[#F5F3EE]/60">
            {t}
          </span>
          <span className="h-1.5 w-1.5 rotate-45 bg-gold/70" />
        </span>
      ))}
    </div>
  );

  return (
    <div
      className="relative overflow-hidden border-y border-[#1A1A1A] bg-[#0b0b0b] py-6"
      data-testid="editorial-marquee"
    >
      <div className="flex w-max animate-marquee">
        <Row />
        <Row ariaHidden />
      </div>
    </div>
  );
}
